import Vue from 'vue'
import App from './App.vue'
import router from './adm/router'
import axiosplugin from './adm/axiosplugin'
import vuetify from './plugins/vuetify';
//import vuedragula from './plugins/vue-dragula';
import store from './adm/store'
//import config from '../config';

Vue.config.performance = true
Vue.config.productionTip = false;
Vue.prototype.$config =config;

const plugin = {
  install () {
    Vue.axios = axiosplugin
    Vue.prototype.$axios = axiosplugin
  }
}

Vue.use(plugin)

new Vue({
  //data: globalData,
  //methods: globalMethods,
  store,
  router,
  vuetify,
  //vuedragula,
  render: h => h(App)
}).$mount('#app')